// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3J8wL","box":"styles_box__1ZT_B"};